"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeProperties = exports.serializeProperties = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
exports.serializeProperties = function (properties) { return json_stable_stringify_1.default(properties); };
exports.deserializeProperties = function (properties) {
    try {
        return properties ? JSON.parse(properties) : {};
    }
    catch (_a) {
        // eslint-disable-next-line no-console
        console.error("Error parsing properties: \"" + properties + "\"");
        return {};
    }
};
//# sourceMappingURL=PropertiesConverter.js.map